<template>
  <TitleContentPage :page="$page" />
</template>

<script>
import { TitleContentPage } from '@/components/templates'
import { PageMetaMixin } from '@/mixins'

export default {
  name: 'Terms',
  mixins: [PageMetaMixin],
  beetPage: 'hunt_terms',
  components: { TitleContentPage },
}
</script>
